import React, { useEffect } from 'react';
import Header from '#/components/Form/Header/Header';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  createActionArtistRelatedError,
  createActionArtistRelatedReset,
  createActionArtistRelatedSetRelatedArtists,
  createActionArtistRelatedStartLoading,
  createActionArtistRelatedStopLoading,
} from '#/redux/actions/artistRelated';
import { TRootState } from '#/redux/store';
import PreviewLayout from '#/components/Layout/PreviewLayout/PreviewLayout';
import ArtistPreview from '#/components/Layout/ArtistPreview/ArtistPreview';
import { ROUTE_NAMES } from '#/router/routes';
import LoadingPage from '#/components/Layout/LoadingPage/LoadingPage';
import {
  emptyRelatedArtistsResponse,
  okResponse,
} from '#/utils/spotifyApiHelpers';

const RelatedArtists = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const relatedArtistsSlice = useSelector(
    (state: TRootState) => state.artistRelated
  );

  const { relatedArtists, _loading, _error } = relatedArtistsSlice;

  const navigate = useNavigate();

  useEffect(() => {
    const getArtistRelatedArtists = async () => {
      if (id) {
        dispatch(createActionArtistRelatedStartLoading());

        const responseRelatedArtists = await okResponse(
          emptyRelatedArtistsResponse
        );

        if ('error' in responseRelatedArtists) {
          // TODO: handle error
          dispatch(createActionArtistRelatedError());
        } else {
          dispatch(
            createActionArtistRelatedSetRelatedArtists(
              responseRelatedArtists.data.artists
            )
          );

          dispatch(createActionArtistRelatedStopLoading());
        }
      }
    };

    getArtistRelatedArtists();
  }, [dispatch, id]);

  useEffect(() => {
    return () => {
      dispatch(createActionArtistRelatedReset());
    };
  }, [dispatch]);

  return (
    <>
      {_loading || _error ? (
        <LoadingPage />
      ) : (
        <div className="p-theme-page-padding">
          <Header
            className=" text-2xl font-bold tracking-tighter mt-4 mb-5"
            type="h1"
          >
            Fans also like
          </Header>
          <PreviewLayout>
            {relatedArtists?.map((artist) => {
              const { id, name, images, uri } = artist;
              const handleOnClick = () =>
                navigate(`${ROUTE_NAMES.ARTIST}/${id}`);
              return (
                <ArtistPreview
                  uri={uri}
                  key={id}
                  onClick={handleOnClick}
                  name={name}
                  image={images[0].url}
                />
              );
            })}
          </PreviewLayout>
        </div>
      )}
    </>
  );
};

export default RelatedArtists;
